"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupCalendarEvents = groupCalendarEvents;
const dayjs_1 = __importDefault(require("dayjs"));
const sortBy_1 = __importDefault(require("../functions/sortBy"));
const sortByFp_1 = __importDefault(require("../functions/sortByFp"));
const mapFp_1 = __importDefault(require("../functions/mapFp"));
const groupByFp_1 = __importDefault(require("../functions/groupByFp"));
const flowFp_1 = __importDefault(require("../functions/flowFp"));
// TODO: used in v1 calendar on OG desktop, save until fully moved to v2
function groupCalendarEvents(events) {
    return (0, flowFp_1.default)((0, mapFp_1.default)((event) => {
        const eventDate = (0, dayjs_1.default)(event.eventDate);
        return {
            ...event,
            eventDateShort: eventDate.format('YY-MM-DD'),
            eventDateSort: +eventDate.format('DD'),
            eventTime: eventDate.format('HH:00'),
            eventTimeSort: +eventDate.format('mm'),
        };
    }), (0, sortByFp_1.default)('eventDateShort'), (0, groupByFp_1.default)('eventDateShort'), (0, mapFp_1.default)((datesList) => {
        var _a, _b;
        return {
            ...datesList[0].tournament,
            groupsByTime: (0, flowFp_1.default)((0, groupByFp_1.default)('eventTime'), (0, mapFp_1.default)((timesList) => {
                var _a;
                return {
                    eventTime: ((_a = timesList[0]) === null || _a === void 0 ? void 0 : _a.eventTime) || '',
                    values: (0, flowFp_1.default)((0, groupByFp_1.default)('tournament.id'), (0, mapFp_1.default)((i) => {
                        var _a, _b, _c, _d, _e;
                        return {
                            tournamentId: `${((_b = (_a = i[0]) === null || _a === void 0 ? void 0 : _a.tournament) === null || _b === void 0 ? void 0 : _b.id) || ''}`,
                            tournamentName: `${((_d = (_c = i[0]) === null || _c === void 0 ? void 0 : _c.tournament) === null || _d === void 0 ? void 0 : _d.name) || ''}`,
                            tournament: (_e = i[0]) === null || _e === void 0 ? void 0 : _e.tournament,
                            events: (0, sortBy_1.default)(i, 'eventTimeSort'),
                        };
                    }))(timesList),
                };
            }), (0, sortByFp_1.default)('eventTime'))(datesList),
            eventDateShort: ((_a = datesList[0]) === null || _a === void 0 ? void 0 : _a.eventDateShort) || '',
            eventDate: ((_b = datesList[0]) === null || _b === void 0 ? void 0 : _b.eventDate) || '',
        };
    }))(events);
}
//# sourceMappingURL=groupCalendarEvents.js.map